import { readStates } from '@/constants/lifecycle';

const customActionsInitialState = () => ({
  items: [],
  ...readStates,
});

export default customActionsInitialState;
